var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "vue-widget-header-button-wrapper" },
    [_vm._t("buttons")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }